import { DataFile, DataFilter } from "interfaces";
import { useGetDataInsight } from "./insights";

interface DifferenceResult {
  test: string;
  stat: string;
  value: number;
  "p-value": number;
  decision:
    | "Too little data"
    | "Not Significant"
    | "Slightly Significant"
    | "Highly significant"
    | "Very highly significant";
  sizes: number[];
}

interface FileComparisonInsight {
  all_columns: string[];
  common_columns: string[];
  comparisons: { [col: string]: DifferenceResult };
}

export const useFetchFileComparisons = (
  fileId: string,
  fileToCompare: string,
  colTypes: DataFile.UserDefinedTypes,
  filters?: DataFilter.Filter[]
) => {
  return useGetDataInsight<FileComparisonInsight>({
    fileId,
    name: "data_file_comparisons",
    params: {
      file_to_compare: fileToCompare,
      column_types: colTypes,
      filters: filters || [],
    },
    enabled: !!fileId && !!fileToCompare,
  });
};
